module.exports = __webpack_public_path__ + "static/notes-a109430e114be2a1ce5aafe80d38f043.png";